export const filterNonEmptyAudiences = ({ audienceSize }) => !!audienceSize && audienceSize > 0;
